/**
 *
 * @param {CartItems} items
 */
export const handleOptimizeLineItemProperties = (items) => {
  window.optimize = window.optimize || {};
  if (window.optimize.added_properties) {
    if (Array.isArray(items)) {
      return items.map((item, index) => {
        if (!index) {
          return {
            ...item,
            properties: {
              ...item.properties,
              ...window.optimize.added_properties,
            },
          };
        }

        return item;
      });
    } else {
      return {
        ...items,
        properties: {
          ...items.properties,
          ...window.optimize.added_properties,
        },
      };
    }
  } else {
    return items;
  }
};
